module.exports = __webpack_public_path__ + "img/logo_smaller.1c1005fc.png";